import React, { useMemo } from 'react';
import { datetime } from "../../../../util/library/datetime";
import { NotificationType, operationType, SHORT_DATETIME_FORMAT } from "../../../../util/varibles/constants";
import { INotification } from "../../../../util/varibles/interface";
import Icon, { ICON_NAME } from "../../../Icon";
import styles from './style.module.scss';

const getIcon = (type: string = '') => {
    const [targetType, subType] = type.split('#');
    switch (targetType) {
        case NotificationType.Operation: {
            const { icon } = operationType[subType] || {};
            return { icon, type: NotificationType.Operation }
        }
        case NotificationType.Contract: {
            return { icon: ICON_NAME.VESSEL, type: NotificationType.Contract }
        }
        default:
            return { icon: null, type: undefined }
    }
}

interface IProps {
    data: INotification

    onClick(data: INotification): void
}

const ViewNotification: React.FC<IProps> = ({ data, onClick }) => {
    const { icon, type } = useMemo(() => getIcon(data.type), [data.type]);
    const { message, date_map = [] } = data;

    const content = useMemo(() => {
        if (typeof message === "string") {
            let result = message;
            date_map.forEach(item => {
                const isValid = datetime(item.value).isValid;
                if (isValid)
                    result = result.replaceAll(`${item.key}`, datetime(item.value).format(SHORT_DATETIME_FORMAT))
            })
            return result;
        }
        return "-";
    }, [message, date_map])

    return <div className={styles.notification} onClick={() => onClick({ ...data, notificationType: type })}>
        <div className={styles.icon}>
            <Icon icon={icon!} />
        </div>
        <div className={styles.content}>
            <div className={styles.message}>
                {content}
            </div>
            <div className={styles.time}>
                {datetime(data.timestamp).format(SHORT_DATETIME_FORMAT)}
            </div>
        </div>
        {!data.read && <div className={styles.read} />}
    </div>;
};

export default React.memo(ViewNotification);
